import React from 'react'
import { HtmlContent } from '@mediahuis/chameleon-react'

export const header = 'Gepersonaliseerde digitale advertenties'
export const accept = 'Ik wil liever relevante advertenties'
export const decline = 'Ik wil evenveel, maar algemene advertenties'

type ContentProps = {
  html: string
}

export const Content: React.FC<ContentProps> = ({ html }) => (
  <HtmlContent>
    <div dangerouslySetInnerHTML={{ __html: html }}></div>
  </HtmlContent>
)
